import type { RootState } from 'features/store/store';

export const selectShowDeveloperFeatures = (state: RootState) =>
  state.devTools.showDeveloperFeatures;
